var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconamoon:profile-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16667 5.83333C7.16667 4.94928 7.51786 4.10143 8.14298 3.47631C8.7681 2.85119 9.61594 2.5 10.5 2.5C11.3841 2.5 12.2319 2.85119 12.857 3.47631C13.4821 4.10143 13.8333 4.94928 13.8333 5.83333C13.8333 6.71739 13.4821 7.56523 12.857 8.19036C12.2319 8.81548 11.3841 9.16667 10.5 9.16667C9.61594 9.16667 8.7681 8.81548 8.14298 8.19036C7.51786 7.56523 7.16667 6.71739 7.16667 5.83333ZM7.16667 10.8333C6.0616 10.8333 5.00179 11.2723 4.22039 12.0537C3.43899 12.8351 3 13.8949 3 15C3 15.663 3.26339 16.2989 3.73223 16.7678C4.20107 17.2366 4.83696 17.5 5.5 17.5H15.5C16.163 17.5 16.7989 17.2366 17.2678 16.7678C17.7366 16.2989 18 15.663 18 15C18 13.8949 17.561 12.8351 16.7796 12.0537C15.9982 11.2723 14.9384 10.8333 13.8333 10.8333H7.16667Z",
    fill: "#9599A0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a642e543efe11630adb938f15fdc77a9.svg";
export { ForwardRef as ReactComponent };